module.exports = {
  MODE_FULL_CONTROL: "full-control",
  MODE_PARTIAL_CONTROL: "partial-control",
  MODE_NO_CONTROL: "no-control",

  TYPE_CURSOR: "cursor",
  TYPE_FORM: "form",
  TYPE_FORM_SYNC: "form-sync",
  TYPE_FORM_FOCUS: "form-focus",
  TYPE_FORM_BLUR: "form-blur",
  TYPE_SCROLL: "scroll",
  TYPE_REQ_FORM_SYNC: "req-form-sync",
  TYPE_HIGHLIGHTER_EVENT: "highlighter-event",
  TYPE_STYLE: "style",

  NODE_PRIMARY_SRC_SUFFIX: "/primary-bundle.js",
  NODE_ID_TAG: "data-co-browsing-node-id",
  NODE_ALLOW_SCRIPTS: "data-8x8-allow-scripts",

  XLINK_NS: "http://www.w3.org/1999/xlink",
  XML_NS: "http://www.w3.org/2000/xmlns/",
  SVG_NS: "http://www.w3.org/2000/svg",

  CO_BROWSING_SCRIPT_TYPE_INTERNAL: "internal",
  CO_BROWSING_SCRIPT_TYPE_EXTERNAL: "external",
  POPUP_IFRAME_NAME: "co-browsing-popup-iframe",
  POPUP_IFRAME_TEST_ID: "co-browsing-popup-iframe_TEST_ID",
  POPUP_MODE_NONE: "none",
  POPUP_MODE_BACKGROUND: "background",
  POPUP_MODE_AVAILABLE: "available",
  POPUP_Z_INDEX_MAX: 2147483647,
  POPUP_Z_INDEX_MIN: -1,
  POPUP_STATE_MINIMIZED: "min",
  POPUP_STATE_MAXIMIZED: "max",
  POPUP_MAXIMIZED_WIDTH: 320,
  POPUP_MAXIMIZED_HEIGHT: 24,
  POPUP_MINIMIZED_WIDTH: 240,
  POPUP_MINIMIZED_HEIGHT: 60,
  POPUP_CONTAINER_DOC_PADDING: 10,
  POPUP_CONTAINER_TOP_OFFSET: 16,
  TOOLBAR_MAXIMIZED_WIDTH: 245,
  TOOLBAR_MAXIMIZED_HEIGHT: 60,
  TOOLBAR_MINIMIZED_WIDTH: 245,
  TOOLBAR_MINIMIZED_HEIGHT: 60,

  DISCONNECTED_LOADING_SCREEN_TIMEOUT: 10000,

  STATUS_CONNECTING: "connecting",
  STATUS_READY: "ready",
  STATUS_CONNECTED: "connected",
  STATUS_REPLICA_DISCONNECTED: "replica-disconnected",
  STATUS_CONNECTION_ERROR: "connection-error",
  STATUS_SYNC_REQUIRED: "sync-required",
  STATUS_INVALID_LICENSE: "invalid-license",
  STATUS_DISABLED_LICENSE: "disabled-license",
  STATUS_LIMITED_LICENSE: "limited-license",
  STATUS_INVALID_DOMAIN_FOR_LICENSE: "invalid-domain-for-license",
  STATUS_DISCONNECTED: "disconnected",
  STATUS_ENDED: "ended",
  STATUS_CUSTOM_STRINGS: "custom-strings",
  STATUS_NOT_STARTED: "not-started",

  EVENT_STATUS: "cobrowsingstatus",

  POPUP_STATE: "popup-state",
  POPUP_DRAG_STARTED: "popup-drag-started",
  POPUP_SET_TIMEOUT: 400,

  HIDDEN_ELEMENTS_BY_CLASS_IN_REPLICA: ["__8x8Chat-Container"],

  // Element add event listener keys
  EVENT_LISTENER_KEY_ESCAPE: "Escape",
  EVENT_LISTENER_KEY_ESCAPE_CODE: 27
};
